import compose from 'lodash/fp/compose';
import filter from 'lodash/fp/filter';
import map from 'lodash/fp/map';
import sortBy from 'lodash/fp/sortBy';
import lowerCase from 'lodash/lowerCase';
import replace from 'lodash/replace';
import React, { useEffect, useMemo, useState } from 'react';

import { createRegExp, filterOption } from '../utils/filter';

export const useSelectSearchProps = (_options, reactiveFlag) => {
  const [search, setSearchValue] = useState();
  
  useEffect(() => {
    setSearchValue('');
  }, [reactiveFlag]);
  
  const searchRegex = useMemo(() => createRegExp(search), [search]);
  
  const options = useMemo(() => compose(
    map(({ label, value }) => {
      const matchedValue = lowerCase(label).match(searchRegex);
      const start = matchedValue?.index;
      const stop = start + matchedValue?.[0]?.length;
      const highLight = String(label).substring(start, stop);
      const _label = replace(label, highLight, `<span class="font-bold text-primary">${highLight}</span>`);
      return ({
        value,
        // eslint-disable-next-line jam3/no-sanitizer-with-danger
        label: (<span dangerouslySetInnerHTML={{ __html: _label }}/>),
      });
    }),
    sortBy(({ label }) => lowerCase(label).match(searchRegex)?.index),
    filter((option) => filterOption(search, option)),
  )(_options), [_options, search, searchRegex]);
  
  return {
    options,
    showSearch: true,
    filterOption: false,
    onSearch: setSearchValue,
  };
};
